import { MessengerEventBus } from '@xometry/ui';
import { AppContext } from 'contexts/AppContext';
import { useCallback, useContext, useMemo } from 'react';

export const useMessengerEventBus = () => {
  const { messengerEventBus, setMessengerEventBus } = useContext(AppContext);

  const setEventBusRef = useCallback(
    (eventBus: MessengerEventBus) => {
      if (messengerEventBus) {
        return messengerEventBus;
      }

      setMessengerEventBus(eventBus);

      return eventBus;
    },
    [messengerEventBus, setMessengerEventBus],
  );

  const sendEvent = useMemo(() => {
    return messengerEventBus?.sendEvent;
  }, [messengerEventBus]);

  return {
    setEventBusRef,
    sendEvent,
  };
};
